// App.tsx - GÜNCELLENMİŞ
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TicketProvider } from './contexts/TicketContext';
import Layout from './components/common/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TicketList from '../src/components/tickets/TicketList';
import Companies from './pages/Companies';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Unauthorized from './pages/Unauthorized';
import CompanyManagement from './components/common/CompanyManagement';

// Loading component...
const LoadingSpinner = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    flexDirection: 'column',
    gap: '20px'
  }}>
    <div>Yükleniyor...</div>
  </div>
);

// Role göre ana sayfa yönlendirmesi
const HomeRedirect: React.FC = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner />;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  switch (user.role) {
    case 'admin':
      return <Navigate to="/dashboard" replace />;
    case 'support':
    case 'customer':
    default:
      return <Navigate to="/tickets" replace />;
  }
};

const AppRoutes: React.FC = () => {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      
      {/* Dashboard - Sadece Admin */}
      <Route path="/dashboard" element={
        <ProtectedRoute requiredRole="admin">
          <Layout>
            <Dashboard />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* TicketList - Tüm kullanıcılar (role-based içerik) */}
      <Route path="/tickets" element={
        <ProtectedRoute>
          <Layout>
            <TicketList />
          </Layout>
        </ProtectedRoute>
      } />
      
      
      {/* Companies - Sadece Admin */}
      <Route path="/companies" element={
        <ProtectedRoute requiredRole="admin">
          <Layout>
            <Companies />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* Reports - Admin ve Support */}
      <Route path="/reports" element={
        <ProtectedRoute requiredRole={['admin', 'support']}>
          <Layout>
            <Reports />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* Profile - Tüm kullanıcılar */}
      <Route path="/profile" element={
        <ProtectedRoute>
          <Layout>
            <Profile />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* Settings - Tüm kullanıcılar */}
      <Route path="/settings" element={
        <ProtectedRoute>
          <Layout>
            <Settings />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* Firma Yönetimi */}
      <Route path="/company-management" element={
        <ProtectedRoute requiredRole="admin">
          <Layout>
            <CompanyManagement />
          </Layout>
        </ProtectedRoute>
      } />
      
      {/* Default redirect - Role göre yönlendirme */}
      <Route path="/" element={<HomeRedirect />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <TicketProvider>
          <AppRoutes />
        </TicketProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
